import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { useTranslation } from "react-i18next";

// Utilisation de liens externes pour placeholders (Picsum Photos)
const importAll = (r) => r.keys().map(r);
const images = importAll(
  require.context(
    "../../assets/img/caroussel_general", // Chemin vers ton dossier d'images
    false,
    /\.(png|jpe?g|svg|webp)$/
  )
);

export default function CarouselDeLoco() {
  const { t } = useTranslation();
  
  return (
  <div className="image-slider-container">
    <h2>{t("carousel.title")}</h2>

    <div className="yellow-bar" />
    <Swiper
      className="image-swiper"
      modules={[Navigation]}
      slidesPerView={3} // Toujours 3 slides visibles
      spaceBetween={20}
      loop={false} // Boucle infinie
      centeredSlides={false} // Alignement à gauche
      navigation
      breakpoints={{
        // Réactivité: 1 slide sur petit écran
        0: { slidesPerView: 1 },
        600: { slidesPerView: 2 },
        900: { slidesPerView: 3 },
      }}
      loopFillGroupWithBlank={true} // Remplit groupe si moins d'images
    >
      {images.map((img, idx) => (
        <SwiperSlide key={idx} className="image-slide">
          <img src={img.default || img} alt={`Slide ${idx + 1}`} />
        </SwiperSlide>
      ))}
    </Swiper>
  </div>
  );
}